<template>
  <div>
    <b-dropdown
      v-model="selectedStatus"
      no-caret
      variant="outline-primary"
      size="sm"
      :class="dropdownClass"
      :toggle-class="toggleClass"
      :disabled="loading || disabled"
    >
      <template #button-content>
        <b-overlay
          :show="loading"
          class="w-auto"
          spinner-variant="primary"
          spinner-small
          variant="light"
          opacity=".8"
          rounded="full"
        >
          <span class="flex items-center justify-between gap-[4px] !py-[5px] !px-[12px]">
            {{ displayText }}
            <span class="k-arrow-down-1 text-[#333333] font-bold" />
          </span>
        </b-overlay>
      </template>
      <b-dropdown-item
        v-for="status in constant.options"
        :key="String(status.value)"
        :disabled="selectedStatus === status.value"
        :class="selectedStatus === status.value ? 'opacity-70 cursor-not-allowed' : ''"
        @click="$emit('need-updated', { value: status.value, oldValue: selectedStatus })"
      >
        <span>{{ status.text }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
/**
 * Component for rendering a generic dropdown cell that handles creator activity tracking.
 * Emits `need-updated` event with the primitive new and old values when a dropdown item is clicked.
 */
export default {
  name: 'SampleCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    statusConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedStatus: this.data[this.type] ?? null,
    }
  },
  computed: {
    constant() {
      return {
        status: this.statusConfig,
        options: this.options,
      }
    },
    displayText() {
      return this.constant.status[this.selectedStatus]?.text ?? 'Pilih Status'
    },
    toggleClass() {
      const { style } = this.constant.status[this.selectedStatus] || ({
        style: {
          mainColor: '#333333',
          subColor: '#F4F4F4',
          borderColor: '#C2C2C2',
        },
      })
      const computedClass = `!bg-[${style.subColor}] !text-[${style.mainColor}]`
      return `!rounded-full !p-0 ${computedClass}`
    },
    dropdownClass() {
      const { mainColor, borderColor } = this.constant.status[this.selectedStatus]?.style || {}
      return `[&_.btn-outline-primary]:!border-[${borderColor ?? mainColor ?? '#C2C2C2'}] w-[130px]`
    },
  },
  watch: {
    data: {
      handler(newData) {
        this.selectedStatus = newData[this.type] ?? null
      },
      deep: true,
    },
  },
  methods: {
    setLoading(state) {
      this.loading = state
    },
    setValue(value) {
      this.selectedStatus = value
    },
  },
}
</script>
